<mat-sidenav-container class="client-container">
  <mat-sidenav
    style="width: 50%; overflow-x: hidden !important"
    #sidenav
    mode="over"
    class="main create-mail"
    position="end"
    [opened]="openAddContactNoteSheetValue"
    disableClose
    [fixedInViewport]="true"
    [fixedTopGap]="60"
  >
    <form [formGroup]="adContactNoteForm">
      <div class="sliding-sheet-header">
        <h4 class="ml-4 pt-1">Past Client Detail</h4>
        <button type="button" (click)="closeAddContactSheet()"><mat-icon>close</mat-icon></button>
      </div>

      <div class="sliding-sheet-body">
        <div class="row">
          <div class="col-md-10 col-sm-12 col-12">
            Property Address
            <p class="w-100 mb-2">
              <b>
                <span *ngIf="getAddressComponentsFromStandardAddress(addContactSheetContext.address) as addr">
                  <div class="street">
                    {{ addr.StreetAddress }}, {{ addr.City }} {{ addr.State }} {{ addr.PostalCode }}
                  </div>
                  <div class="street">
                    <a
                      *ngIf="subscribedEmails?.length != 0"
                      href="javascript:void(0)"
                      class="unsubscribe"
                      (click)="openDialog(unsubscribe)"
                    >
                      Unsubscribe
                    </a>
                  </div>
                </span></b
              >
            </p>
          </div>
        </div>
        <div class="clientDetails">
          <h6 class="client-head">Client Details</h6>
          <div class="row">
            <div class="col-md-4 col-sm-4 col-12">
              <div>
                <!-- Client Name <br /> -->
                <mat-form-field class="w-100 mb-3">
                  <input
                    matInput
                    class="capitalize"
                    formControlName="clientOneName"
                    placeholder="Client Name"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-12">
              <div>
                <!-- Client Email <br /> -->
                <mat-form-field class="w-100 mb-3">
                  <input matInput formControlName="clientOneEmail" placeholder="Client Email" autocomplete="off" />
                  <mat-error *ngIf="adContactNoteForm.get('clientOneEmail')?.hasError('email')">
                    Enter a valid email
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-12">
              <div>
                <!-- Client Phone <br /> -->
                <mat-form-field class="w-100 mb-3">
                  <input
                    matInput
                    formControlName="clientOnePhoneNumber"
                    placeholder="Client Phone"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="clientDetails" *ngIf="adContactNoteForm.get('clientTwoName')?.value">
            <div class="row">
              <div class="col-md-4 col-sm-4 col-12">
                <mat-form-field class="w-100 mb-3">
                  <input
                    class="capitalize"
                    matInput
                    formControlName="clientTwoName"
                    placeholder="Client Name"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>

              <div class="col-md-4 col-sm-4 col-12">
                <mat-form-field class="w-100 mb-3">
                  <input matInput formControlName="clientTwoEmail" placeholder="Client Email" autocomplete="off" />
                </mat-form-field>
              </div>

              <div class="col-md-4 col-sm-4 col-12">
                <mat-form-field class="w-100 mb-3">
                  <input
                    matInput
                    formControlName="clientTwoPhoneNumber"
                    placeholder="Client Phone"
                    autocomplete="off"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <mat-error *ngIf="adContactNoteForm.get('clientOneEmail')?.hasError('required')">
            Enter at least one contact with both name and email
          </mat-error>
        </div>

        <div class="ownerDetails">
          <h6 class="client-head">Owner Details</h6>

          <div class="row">
            <div class="col-md-4 col-sm-4 col-12">
              <mat-form-field class="w-100 mb-3">
                <input
                  class="capitalize"
                  matInput
                  formControlName="currentOwnerOneName"
                  placeholder="Owner Name"
                  autocomplete="off"
                />
              </mat-form-field>
            </div>

            <div class="col-md-4 col-sm-4 col-12">
              <mat-form-field class="w-100 mb-3">
                <input matInput formControlName="currentOwnerOneEmail" placeholder="Owner Email" autocomplete="off" />
              </mat-form-field>
            </div>
          </div>

          <div class="ownerDetails" *ngIf="adContactNoteForm.get('currentOwnerTwoName')?.value">
            <div class="row">
              <div class="col-md-4 col-sm-4 col-12">
                <mat-form-field class="w-100 mb-3">
                  <input matInput formControlName="currentOwnerTwoName" placeholder="Owner Name" autocomplete="off" />
                </mat-form-field>
              </div>

              <div class="col-md-4 col-sm-4 col-12">
                <mat-form-field class="w-100 mb-3">
                  <input matInput formControlName="currentOwnerTwoEmail" placeholder="Owner Email" autocomplete="off" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Transaction Date <br /><b>
                {{ addContactSheetContext?.closeDate ? (addContactSheetContext?.closeDate | date: 'MM/dd/yy') : '--' }}
              </b>
            </p>
          </div>
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Transaction Type <br /><b>
                {{ addContactSheetContext?.transactionType ? addContactSheetContext?.transactionType : '--' }}
              </b>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Sold Price <br /><b>
                {{
                  addContactSheetContext?.closePrice
                    ? (addContactSheetContext?.closePrice | currency: 'USD':'symbol':'1.0-0')
                    : '--'
                }}
              </b>
            </p>
          </div>
          <div class="col-md-4 col-sm-4 col-12">
            <p>
              Commission <br /><b>
                {{
                  addContactSheetContext?.closePrice
                    ? ((addContactSheetContext.closePrice * 3) / 100 | currency: 'USD':'symbol':'1.0-0')
                    : '--'
                }}
              </b>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 col-sm-12 col-12">
            <h6>Notes</h6>
            <mat-form-field appearance="outline" class="w-100">
              <textarea
                formControlName="note"
                placeholder="Type your message..."
                class="responsive-textarea"
                rows="3"
                matInput
              ></textarea>
              <mat-error *ngIf="adContactNoteForm.get('note')?.hasError('required')"> Note is required </mat-error>
              <mat-error *ngIf="adContactNoteForm.get('note')?.hasError('minlength')">
                Note must be at least 15 characters
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="mb-3" style="float: left">
          <button
            class="my-2 save-contact mr-2"
            type="button"
            (click)="updateContactNoteSheet()"
            color="primary"
            mat-stroked-button
          >
            Save
          </button>
          <button color="primary" mat-flat-button (click)="openDialog(dialogTemplate)" class="my-2 save-contact">
            Automate Marketing
          </button>
        </div>
        <div class="clearfix">&nbsp;</div>
      </div>
    </form>
    <ng-template #dialogTemplate>
      <h2 mat-dialog-title>Automated Marketing</h2>
      <mat-dialog-content>
        <p>Who would you like to add to this automated marketing campaign?</p>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Choose recipient(s)</mat-label>
          <mat-select multiple [(value)]="selectedEmails">
            <mat-option *ngFor="let mail of emailList" [value]="mail" [disabled]="disabledEmails?.includes(mail)">
              {{ mail }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="primary" (click)="submitCampaign()" [pmx-progress-button]="isLoading">
          Send
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #unsubscribe>
      <h2 mat-dialog-title>Unsubscribe Automated Marketing</h2>
      <mat-dialog-content>
        <p>Do you really want to Unsubscribe ?</p>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Choose recipient(s)</mat-label>
          <mat-select multiple [(value)]="selectedEmailList">
            <mat-option *ngFor="let mail of subscribedEmails" [value]="mail" [disabled]="subscribedEmails.length === 1">
              {{ mail }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="closeDialog()">No</button>
        <button mat-raised-button color="primary" (click)="unsubscribeMarketing()">Yes</button>
      </mat-dialog-actions>
    </ng-template>
  </mat-sidenav>
</mat-sidenav-container>
